import styles from '../Footer.module.scss.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const ResponsibleGaming = ({
  rgComponent
}) => /* @__PURE__ */ jsxs("div", {
  className: styles.rgContent,
  "data-test-id": "footer-rg-content",
  children: [/* @__PURE__ */ jsxs("div", {
    suppressHydrationWarning: true,
    children: ["\xA9 Betfair Interactive US LLC, ", (/* @__PURE__ */ new Date()).getFullYear()]
  }), rgComponent, /* @__PURE__ */ jsxs("div", {
    children: ["Persons under 21 are not permitted to engage in sports wagering. For customer support please", " ", /* @__PURE__ */ jsx("a", {
      href: "https://sportsbook.fanduel.com/support",
      target: "_blank",
      rel: "noopener noreferrer",
      "data-test-id": "footer-rg-support",
      children: "contact us"
    }), "."]
  })]
});

export { ResponsibleGaming as default };
//# sourceMappingURL=ResponsibleGaming.js.map
